import { action, computed, observable } from "mobx";
import SystemRepository from "repositories/systemRepository";
import ServerTimeResponse from "entities/serverTimeResponse";
import { format, getTimezoneOffset, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

function parseServerDateAsLocal(serverDate: Date): Date {
  const pragueDate = utcToZonedTime(serverDate, "Europe/Prague");
  return new Date(
    pragueDate.getFullYear(),
    pragueDate.getMonth(),
    pragueDate.getDate(),
    pragueDate.getHours(),
    pragueDate.getMinutes(),
    pragueDate.getSeconds(),
    pragueDate.getMilliseconds()
  );
}

export default class TimeService {
  @observable isServerTimeSame?: boolean;
  @observable currentServerTime: Date;
  @observable isPositivezone = new Date().getTimezoneOffset() <= 0;
  @observable isFetched: Boolean;
  private serverTimeFetched = false; // Flag pro kontrolu, zda už byl server time načten

  constructor(private systemRepository: SystemRepository) {
    this.isFetched = false;
  }

  @computed
  get serverTime(): Date {
    return this.currentServerTime;
  }

  @action.bound
  async getCurrentServerTime(onflyFetch = false) {
    const response = await this.systemRepository.getCurrentServerTime();
    if (onflyFetch && response instanceof ServerTimeResponse) {
      return response.currentServerTime;
    }
    if (response instanceof ServerTimeResponse) {
      const serverDate = response.currentServerTime;
      const finalDate = parseServerDateAsLocal(serverDate);

      const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const serverOffset = getTimezoneOffset("Europe/Prague", serverDate);
      const userOffset = getTimezoneOffset(userTZ, new Date());

      const serverDay = format(serverDate, "yyyy-MM-dd", { timeZone: "Europe/Prague" });
      const userDay = format(new Date(), "yyyy-MM-dd", { timeZone: userTZ });
      this.isServerTimeSame = serverOffset === userOffset && serverDay === userDay;
      this.currentServerTime = finalDate;
      this.isFetched = true;
      this.serverTimeFetched = true; // Označíme, že server time byl načten
    } else {
      this.isFetched = false;
      this.currentServerTime = new Date();
    }
    return this.currentServerTime;
  }
}
